<template>
  <div id="wrapper">
    <navigation></navigation>
    <main>
      <router-view></router-view>
    </main>
    <bottom></bottom>
  </div>
</template>

<script>
import Navigation from "@/components/Header.vue";
import Bottom from "@/components/Footer.vue";

export default {
  components: {
    Navigation,
    Bottom,
  },
};
</script>

<style lang="scss">
html,
body {
  background-color: white !important;
  height: 100%;
}

* {
  font-family: $font-base;
  color: black;
  font-weight: 300 !important;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  color: $primary-color;
  font-weight: 500 !important;
}

p,
span {
  font-size: 1.1em;
  line-height: 23px;
}

ul {
  list-style-type: none;
}

button {
  border: none !important;
  &:focus {
    outline: none;
  }
}

button.btn-primary {
  padding: 0.5em 3.5em !important;
  text-transform: uppercase;
  font-weight: 500 !important;
  border-radius: 6px;
  box-shadow: 0px 7px 27px rgba(0, 0, 0, 0.07);
  &:hover {
    background-color: $secondary-color !important;
  }
}

.btn-group {
  box-shadow: 0px 7px 27px rgba(0, 0, 0, 0.07);
}

button:focus {
  outline: none !important;
}

button.btn-light {
  padding: 0.5em 0 !important;
  width: 12em;
  text-transform: uppercase;
  font-weight: 500 !important;
  border-radius: 6px;
  &.active {
    color: white !important;
    background-color: $primary-color !important;
  }
  @include media-breakpoint-down(sm) {
    width: 7.9em;
  }
}

.section {
  padding: 4em 5em !important;
  overflow-x: hidden;
  @include media-breakpoint-down(md) {
    padding: 4em 1em !important;
    .title {
      margin-bottom: 2em;
    }
  }
}

.page {
  padding: 9em 5em 5em 5em !important;
  background-color: $light-grey;
  overflow-x: hidden;
  min-height: calc(100vh - 88px);
  @include media-breakpoint-down(md) {
    padding: 9em 1em 5em 1em !important;
  }
}

.title {
  margin-bottom: 3em;
}

.publications {
  h2 {
    color: $secondary-color;
  }

  #no-publication {
    margin-top: 5em;

    :first-child {
      color: $primary-color;
      font-size: 30px;
      margin-bottom: 0.5em;
    }

    p {
      text-transform: uppercase;
      color: $primary-color;
      font-size: 20px;
    }
  }

  .publications-list {
    li {
      font-size: 18px;
      line-height: 1.3em;
      margin-bottom: 2em;

      &:last-child {
        margin-bottom: 0;
      }

      &:first-child {
        margin-top: 1em;
      }

      .bullet-point {
        position: absolute;

        * {
          position: relative;
          right: 3em;
          bottom: 0.2em;
          font-size: 12px;
          color: $secondary-color;
        }
      }

      .publication-info {
        div,
        a {
          text-decoration: none;

          .pub-header {
            text-transform: uppercase;
            font-size: 18px;
            color: $primary-color;
            height: 20px;
          }

          .pub-authors:last-child span {
            display: none;
          }
        }

        a:hover > .pub-header-title {
          font-weight: 400 !important;
        }

        @include media-breakpoint-down(sm) {
          div,
          a {
            display: block !important;

            .ml-3 {
              margin-left: 0 !important;
            }

            .pub-header-title {
              font-weight: 400 !important;
            }
          }
        }
      }
    }
  }
}

.dropdown-publications-years {
  background-color: white !important;
  color: $primary-color !important;
  font-weight: 500 !important;
  font-size: 18px !important;
  border-radius: 5px !important;
  text-transform: uppercase;
  width: 10em !important;
  cursor: pointer;
  box-shadow: 0px 7px 27px rgba(0, 0, 0, 0.07) !important;
  border: none !important;

  background-image: linear-gradient(45deg, transparent 50%, $primary-color 60%),
    linear-gradient(135deg, $primary-color 40%, transparent 50%) !important;
  background-position: calc(100% - 22px) 18px, calc(100% - 15px) 18px, 100% 0 !important;
  background-size: 7px 7px, 7px 7px !important;
  background-repeat: no-repeat !important;
  -webkit-appearance: none;
  -moz-appearance: none;

  &:focus {
    box-shadow: none !important;
  }

  @include media-breakpoint-down(sm) {
    margin-top: 0.5em;
    margin-right: 0.5em;
  }
}

.search-bar {
  background-color: white;
  color: $primary-color !important;
  font-weight: 500 !important;
  font-size: 18px !important;
  border-radius: 5px;
  text-transform: uppercase;
  max-width: 33.5rem !important;
  box-shadow: 0px 7px 27px rgba(0, 0, 0, 0.07) !important;

  &:focus {
    box-shadow: none !important;
    border-color: $primary-color !important;
  }

  @include media-breakpoint-down(sm) {
    margin-top: 0.5em;
  }
}

.search-bar::placeholder {
  color: $primary-color !important;
  opacity: 0.5 !important;
}

.search-button {
  background-color: $primary-color !important;
  color: white !important;
  font-weight: 500 !important;
  font-size: 18px !important;
  border-radius: 5px !important;
  text-transform: uppercase;
  width: 8em;
  box-shadow: 0px 7px 27px rgba(0, 0, 0, 0.07) !important;
  border: none;

  &:focus {
    box-shadow: none !important;
  }

  @include media-breakpoint-down(sm) {
    margin-top: 0.5em;
    margin-right: 0.5em;
  }
}

.search-button:disabled {
  opacity: 20% !important;
  cursor: not-allowed;
}

.sort-by-label {
  color: $primary-color;
  font-weight: 500 !important;
  font-size: 19px !important;
  text-transform: uppercase;
}

.partners-list li {
  font-size: 18px;
  line-height: 0.6em;
  margin-bottom: 1.7em;

  &:last-child {
    margin-bottom: 0;
  }

  &:first-child {
    margin-top: 1.5em;
  }

  span {
    position: absolute;

    * {
      position: relative;
      right: 3em;
      bottom: 0.7em;
      font-size: 12px;
      color: $secondary-color;
    }
  }
}
</style>
